import { Database02Icon } from '@langchain/untitled-ui-icons';

import { cn } from '@/utils/tailwind';

const DatasetIcon = (props: { className?: string }) => {
  return <Database02Icon className={cn('size-4', props.className)} />;
};

export default DatasetIcon;
